import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  radioSection: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    marginBottom: 0,
    marginTop: '9px',
  },
  radioSectionLabel: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: '600',
    color: theme.evPalette.nickel[700],
    lineHeight: theme.typography.pxToRem(16),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.typography.pxToRem(10),
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1.5),
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    marginLeft: '2px',
  },
  radioContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    cursor: 'pointer',
  },
  radioButton: {
    padding: theme.spacing(0.5),
    '& .MuiSvgIcon-root': {
      fontSize: '18px',
    },
  },
  radioLabel: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: '400',
    color: theme.evPalette.charcoal[900],
    cursor: 'pointer',
    userSelect: 'none',
  },
}));
